import React from 'react';

import {
	ContextualInviteNudgeFlagLoadable,
	LIVE_PAGE_SOURCE,
} from '@confluence/contextual-invite-nudge-flag';
import { Attribution } from '@confluence/error-boundary/entry-points/Attribution';
import { withTransparentErrorBoundary } from '@confluence/error-boundary/entry-points/withErrorBoundary';

import { useLivePageInviteNudgeStore } from './useLivePageInviteNudgeStore';

type LivePageInviteNudgeComponentProps = {
	contentId: string;
	contentType: string;
	spaceKey?: string;
};

const LivePageInviteNudgeComponent = ({
	contentId,
	contentType,
	spaceKey,
}: LivePageInviteNudgeComponentProps) => {
	const [{ hasLivePageChanges }] = useLivePageInviteNudgeStore();

	if (!hasLivePageChanges) {
		return null;
	}

	return (
		<ContextualInviteNudgeFlagLoadable
			contentId={contentId}
			contentType={contentType}
			spaceKey={spaceKey}
			source={LIVE_PAGE_SOURCE}
		/>
	);
};

export const LivePageInviteNudge = withTransparentErrorBoundary({
	attribution: Attribution.FLYWHEEL_ACTIVATION,
})(LivePageInviteNudgeComponent);
